import { useCallback, useState } from 'react';
import { DirectCampaignUI } from '../../../../data-layer/direct/types';
import { ContentPromotionDateValue } from '../../../../ui/business/ContentPromotionDate/types';
import { formatDateToStr } from '../../../../utils/format/formatDate';

export const usePromotionDate = (company?: DirectCampaignUI) => {
    const startDate = new Date();
    const formattedStartDate = formatDateToStr(startDate);
    const companyDate = company?.startDate;
    const [date, setDate] = useState<string>(companyDate || formattedStartDate);
    const onChangeDate = useCallback((value: string) => {
        setDate(value);
    }, []);

    const [dateValue, setDateValue] = useState(
        startDate ? ContentPromotionDateValue.CHOICE : ContentPromotionDateValue.NOW,
    );
    const onChangeDateValue = useCallback(
        (value: ContentPromotionDateValue) => {
            setDateValue(value);

            if (value === ContentPromotionDateValue.NOW) {
                setDate(formattedStartDate);
            }
        },
        [formattedStartDate],
    );

    return {
        enableDateEdit: !companyDate || new Date(companyDate) > startDate,
        dateValue,
        onChangeDateValue,
        date,
        startDate,
        onChangeDate,
    };
};
